import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '~/components/atoms/buttons/Button';

import styles from './styles.module.scss';
import { ReactComponent as DiscountIcon } from '../../assets/discount.svg';

type Props = {
  onClick: () => void;
};

const BlackFridaySuggestionButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      fullWidth
      color="secondary"
      variant="contained"
      startIcon={<DiscountIcon width="24" height="24" />}
      onClick={onClick}
      className={styles.button}
    >
      {t('black_friday:suggestion_button', 'Black Friday 85% Off')}
    </Button>
  );
};

export default BlackFridaySuggestionButton;
